export default function ScrollingMod(isModal) {
    const bodyNode = document.getElementsByTagName("body")[0]
    if (isModal) {
        bodyNode.style.overflow = "hidden"
    } else {
        bodyNode.style.overflow = "scroll"
    }
}